// Assets que viajan dentro del HTML de los correos.
//
// El logo era `https://production-habit.s3.amazonaws.com/habit/Habit+Logo.png`, escrito a mano
// en 9 lugares: un objeto público del bucket production-habit de la Cuenta B. Con una cuenta por
// app ese bucket se apaga y los correos ya enviados se quedan sin logo, así que la referencia
// tiene que salir de ahí. Copiarlo al bucket de habit no sirve: el bucket nuevo queda privado y
// no tiene por qué dejar de serlo para servir una imagen. Y no hace falta — la propia app ya
// sirve estáticos, y de hecho ya sirve su propio logo.
//
// Se arma con `window.location.origin` y no con `endpoints.app_url` a propósito. El correo se
// compone en el navegador, así que el origin es el host que en ese momento está sirviendo la
// app: no puede estar mal.
//
// El que se manda es `/logo-new.png`, el logo propio de la app: el mismo que ya se ve en la
// barra de navegación y en las pantallas de login.
export const LOGO_CORREO = `${window.location.origin}/logo-new.png`
